import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { Table } from "react-bootstrap";
import { FileUploader } from "./Component/AssetImportUploader";
import { logDOM } from "@testing-library/react";
import {
  DeleteServiceCaller,
  GetServiceCaller,
  PostFormServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import moment from "moment";

const ImportAsset = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Import Asset"));
  }, []);
  const [formData, setFormData] = useState({});
  const [fileName, setFileName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showApiAssetData, setShowApiAssetData] = useState([]);

  useEffect(() => {
    fetchShowApiImportAsset();
  }, []);

  const fetchShowApiImportAsset = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}get-asset-import-data`
      );
      if (response?.status === 200) {
        setShowApiAssetData(response?.data?.data);
      }
    } catch (error) {
      console.error("FEtching Api error ");
    }
  };



const handleFileSelection = (file) => {
  setSelectedFile(file); // ✅ Set the file
};
  const handleSubmit = async () => {
    let toastShown = false;
    if (!selectedFile) {
      toast.error("Please select a file before submitting.", {
        position: "top-right",
      });
      return;
    }

    const allowedFileTypes = [
      "text/csv",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];
    const fileExtension = selectedFile.name.split(".").pop().toLowerCase();

    if (
      !allowedFileTypes.includes(selectedFile.type) ||
      !["csv", "xls", "xlsx"].includes(fileExtension)
    ) {
      toast.error(
        "Invalid file type. Please upload a CSV, XLS, or XLSX file.",
        { position: "top-right" }
      );
      return;
    }

    const formFilePost = new FormData();
    formFilePost.append("csv", selectedFile);

    try {
      setLoading(true);
      setError(null);

      const config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (e) =>
          console.log(
            `Upload Progress: ${Math.round((e.loaded * 100) / e.total)}%`
          ),
      };

      const response = await PostFormServiceCaller(
        `${API_URL}asset-import-file`,
        formFilePost,
        config
      );

      if (response?.status === 200) {
        fetchShowApiImportAsset();
        setSelectedFile(null);
        setFormData((prevState) => ({
          ...prevState,
          uploadedFileName: response?.data?.file_name,
        }));
        toast.success("File uploaded successfully!", { position: "top-right" });
      }
      window.location.reload();
    } catch (err) {
      console.error("File upload failed:", err);
      setError(err.response?.data?.message || "Failed to upload file.");
  
      const errorMessage = err.response?.data?.message;
      const duplicateList = err.response?.data?.data;
 
      if (errorMessage && Array.isArray(duplicateList) && !toastShown) {
        toast.error(`${errorMessage}: ${duplicateList.join(", ")}`, {
          position: "top-right",
        });
        toastShown = true;
      }
    } finally {
      setLoading(false);
    }
    
  };

  const downloadSampleFile = async () => {
    try {
      // Call the API to get the file URL
      const fileUrl = await GetServiceCaller(`${API_URL}download-sample`);
      const url = fileUrl?.data?.data;
      if (url) {
        // Create a temporary anchor element to trigger the download
        const link = document.createElement("a");

        link.href = url; // The URL from the API response
        link.download = "Sample.csv"; // The name for the downloaded file
        document.body.appendChild(link); // Append the link to the DOM
        link.click(); // Programmatically click the link to trigger the download
        document.body.removeChild(link); // Remove the link from the DOM
      } else {
        console.error("File URL is empty or undefined.");
      }
    } catch (error) {
      console.error("Error fetching or downloading the sample file:", error);
    }
  };

  const handlePostAssetList = async () => {
    try {
      if (showApiAssetData != "") {
        const response = await PostServiceCaller(
          `${API_URL}import-asset`,
          showApiAssetData,
          "post"
        );

        if (response?.status === 200) {
          toast.success("Data Submitted Successfully ", {
            position: "top-right",
          });
          fetchShowApiImportAsset();
          navigate(`/add-asset`);
        }
      } else {
        toast.error("No Data Available", { position: "top-right" });
      }
    } catch (error) {
      console.error("Data Not Submitted SuccessFully ", error);
    }
  };

  const handleDeleteTempAssetList = async () => {
    try {
      const response = await DeleteServiceCaller(
        `${API_URL}delete-csv`,
        {},
        "Delete"
      );

      if (response?.status === 200) {
        toast.success("Data Deleted Successfully", { position: "top-right" });
        fetchShowApiImportAsset();
      }
    } catch (error) {
      console.error("Error While Deleting  the Data ", error);
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="card rounded mt-4">
            <div className="card-body">
              <div className="row">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center">
                    <FileUploader handleFile={handleFileSelection} />
                    {selectedFile && (
                      <span className="ms-2">File : {selectedFile?.name}</span>
                    )}
                  </div>

                  <div>
                    <button
                      className="custom-btn me-2"
                      onClick={downloadSampleFile}
                    >
                      <i className="bi bi-download"></i>Template
                    </button>
                    <button
                      className="custom-btn me-2"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      Submit
                    </button>
                    <button
                      className="cancel-btn me-2"
                      onClick={() => navigate(`/add-asset`)}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showApiAssetData.length != 0 ? (
          <>
            <div className="row">
              <div className="card rounded mt-4">
                <div className="card-body">
                  <div className="row">
                    <Table bordered striped rounded>
                      <thead id="thcolor" className="text-center">
                        <tr>
                          <th>ID</th>
                          <th>Description</th>
                          <th>Make</th>
                          <th>Model</th>
                          <th>Category</th>
                          <th>Asset Type</th>
                          <th>Expiry Date</th>
                          <th>Invoice Number</th>
                          <th>Asset Price</th>
                          <th>Allocated</th>
                          <th>Purchase Date</th>
                          <th>Warranty Date</th>
                          <th>Vendor</th>
                          <th>Service Tag No</th>
                        </tr>
                      </thead>
                      <tbody>
                        {showApiAssetData?.map((ele, index) => (
                          <tr>
                            <td>{ele?.ID}</td>
                            <td>{ele?.Description}</td>
                            <td>{ele?.BrandName_1158}</td>
                            <td>{ele?.ModelName_1159}</td>
                            <td>{ele?.CategoryName_1160}</td>
                            <td>{ele?.AssetType}</td>
                            <td>
                              {moment(ele?.ExpiryDate).format("DD-MMM-YYYY")}
                            </td>
                            <td>{ele?.InvoiceNumber}</td>
                            <td>{ele?.AssetPrice}</td>
                            <td>{ele?.AllocationLabel}</td>
                            <td>
                              {moment(ele?.PurchaseDate).format("DD-MMM-YYYY")}
                            </td>
                            <td>
                              {moment(ele?.WarrantyDate).format("DD-MMM-YYYY")}
                            </td>
                            <td>{ele?.vendorsName}</td>
                            <td>{ele?.BatchNo}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <div className="row">
                    <div className="container">
                      <div className="d-flex justify-content-end mt-2">
                        <div className="d-flex">
                          <div>
                            <button
                              type="button"
                              className="  custom-btn me-2 btn-sm"
                              onClick={() => handlePostAssetList()}
                            >
                              Import Asset
                            </button>
                          </div>
                          <div>
                            <button
                              type="button"
                              className="btn  btn-sm btn-danger "
                              onClick={() => handleDeleteTempAssetList()}
                            >
                              Delete CSV
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>
              </div>{" "}
            </div>
          </>
        ) : null}
      </div>
    </>
  );
};

export default ImportAsset;
